//Ovaltine Club
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import survey from "@/navigation/survey";

//Ovaltine Club Custom module
import overall from "@/constants/navigation/B2TJ9OYIZBO1/menu/overall";
import dataManagementCustom from "@/constants/navigation/B2TJ9OYIZBO1/menu/data-management";

const { decodeToken } = useDecodeToken();

const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVnp9phhnm7LfA": // Dev Ovaltine Club BO EP
    case "PVgRFd8EY5UK2D": // Prod Ovaltine Club BO EP
      switch (decodeToken()?.sub) {
        case "ID_USPiyE8FZu1X": //dev kunaporn.jaimakham@twiningsovo.com
        case "ID_akEDXgn2sdeM": //prod kunaporn.jaimakham@twiningsovo.com
        case "ID_i1Ambj3qhQnD": //dev Anuchanun.kajontammakun@twiningsovo.com
        case "ID_tHsARtcfNsm9": //prod Anuchanun.kajontammakun@twiningsovo.com
          return [
            ...banner,
            ...article,
            ...tags,
            ...report,
            ...dataManagementCustom,
            ...overall,
          ];
      }
    default:
      return [
        ...banner,
        ...article,
        ...tags,
        ...report,
        ...dataManagementCustom,
        ...inventory,
        ...privileges,
        ...fulfillment,
        ...overall,
      ];
  }
};

export default renderNavByPermission();
